import { z } from 'zod';

export const cropSchema = z.object({
  id: z.string().regex(/^crop_[a-z0-9_]+$/),
  name: z.string().min(1),
  emoji: z.string().min(1),
  unlockLevel: z.number().int().min(1).max(15),
  growSeconds: z.number().int().positive(),
  seedPrice: z.number().int().nonnegative(),
  sellPrice: z.number().int().positive(),
  harvestXp: z.number().int().nonnegative(),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
});

export const furnitureCatalogSchema = z.object({
  themes: z.array(
    z.object({
      id: z.string().min(1),
      name: z.string().min(1),
      color: z.string(),
      priceMultiplier: z.number().positive(),
    }),
  ),
  types: z.array(
    z.object({
      id: z.string().min(1),
      name: z.string().min(1),
      width: z.number().int().positive(),
      height: z.number().int().positive(),
      layer: z.enum(['floor', 'furniture', 'wall']),
      basePrice: z.number().int().positive(),
    }),
  ),
});

export const clothingCatalogSchema = z.object({
  colors: z.array(z.object({ id: z.string(), name: z.string(), value: z.string() })),
  pieces: z.array(
    z.object({
      slot: z.enum(['hat', 'top', 'bottom', 'shoes', 'dress']),
      name: z.string(),
      basePrice: z.number().int().positive(),
    }),
  ),
});

export const questSchema = z.object({
  id: z.string().min(1),
  kind: z.enum(['daily', 'growth']),
  name: z.string().min(1),
  eventType: z.enum([
    'cropPlanted',
    'cropHarvested',
    'itemSold',
    'furniturePlaced',
    'clothingEquipped',
    'clothingOwned',
    'houseUpgraded',
  ]),
  target: z.number().int().positive(),
  rewardCoins: z.number().int().nonnegative(),
  rewardXp: z.number().int().nonnegative(),
});
